import React from 'react'
import classNames from 'classnames'
import LabelNumber from './partials/LabelNumber'

function Label({ text, number, modifierClasses = [] }) {
  const labelClasses = classNames(
    'label',
    modifierClasses
  )
  return (
    <div
      className={labelClasses}
    >
      {text}

      {number >= 0 && (
        <LabelNumber number={number} />
      )}
    </div>
  )
}

export default Label
